import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import {
  REQUIREMENT_TYPE_OPTIONS,
  normalizeRequirementType,
} from '../../utils/requirementType';
import { updateRequirementType } from '../../services/requirementService';
import { showSuccess, showError } from '../../utils/toast';
import { getApiErrorMessage } from '../../utils/apiError';

function RequirementTypeSelect({
  requirementId,
  value,
  onUpdated,
  disabled = false,
  className = 'form-select form-select-sm',
}) {
  const [saving, setSaving] = useState(false);
  const normalized = normalizeRequirementType(value);

  const handleChange = async (event) => {
    const nextType = event.target.value;
    if (!requirementId || !nextType || nextType === normalized) return;

    setSaving(true);
    try {
      const response = await updateRequirementType(requirementId, nextType);
      onUpdated?.(nextType, response?.requirement);
      showSuccess('Requirement type updated successfully ✓');
    } catch (error) {
      console.error('Requirement type update failed:', error);
      showError(getApiErrorMessage(error, 'Failed to update requirement type.'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Form.Select
      size="sm"
      className={className}
      value={normalized}
      onChange={handleChange}
      disabled={disabled || saving || !requirementId}
      aria-label="Requirement type"
    >
      {!normalized && <option value="">Select type</option>}
      {!REQUIREMENT_TYPE_OPTIONS.includes(normalized) && normalized ? (
        <option value={normalized}>{normalized}</option>
      ) : null}
      {REQUIREMENT_TYPE_OPTIONS.map((option) => (
        <option key={option} value={option}>{option}</option>
      ))}
    </Form.Select>
  );
}

export default RequirementTypeSelect;
